import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    ticker: {},
    marketWatch: [],
    toasts: [],
    myScripts: [],
    buysell: '',
    buySellData: {},
    buysellCount: 0,
    executedOrders: [],
    openOrders: [],
    positions: [],
    holdings: [],
    orderFirstTimeFlag: true,
    marketWatchFirstTimeFlag: true,
    positionFirstTimeFlag: true,
    userFirstTimeFlag: true,
    holdingFirstTimeFlag: true,
    setVirtualMoney: false,
    dailyPosReport: false,
    user: {},
    showMw: false,
    clearHistory: false,
    chartMw: {},
    feedback: false,
    darkMode: localStorage.getItem('darkMode') === 'true'
  },
  getters: {
    buysell: state => state.buysellCount
  },
  mutations: {
    updateTick (state, tick) {
      state.ticker = tick
    },
    updateUser (state, user) {
      state.user = user
    },
    showMw (state, flag) {
      state.showMw = flag
    },
    updateMyScripts (state, script) {
      state.myScripts = script
    },
    addToMyScripts (state, script) {
      state.myScripts.push(script)
    },
    removeMyScripts (state, script) {
      const index = state.myScripts.findIndex((s) => s === script) // find toast
      state.myScripts.splice(index, 1)
    },
    updateMarketWatch (state, mw) {
      state.marketWatch = mw
    },
    addToMarketWatch (state, mw) {
      state.marketWatch.push(mw)
    },
    removeMyMarketWatch (state, instrumentToken) {
      const index = state.marketWatch.findIndex((s) => s.instrumentToken === instrumentToken) // find toast
      state.marketWatch.splice(index, 1)
    },
    addToast (state, toast) {
      state.toasts.push(toast)
    },
    clearToast (state, title) {
      const index = state.toasts.findIndex((toast) => toast.title === title) // find toast
      state.toasts.splice(index, 1) // remove toast from array
    },
    setBuySell (state, data) {
      state.buysell = data.type
      state.buySellData = data.mw
      state.buysellCount++
    },
    closeBuySell (state) {
      state.buysell = ''
    },
    updateExecutedOrder (state, data) {
      state.executedOrders = data
    },
    addExecutedOrder (state, data) {
      state.executedOrders.unshift(data)
    },
    addOpenOrder (state, data) {
      state.openOrders.unshift(data)
    },
    updateOpenOrder (state, data) {
      state.openOrders = data
    },
    updatePosition (state, data) {
      state.positions = data
    },
    updateHolding (state, data) {
      state.holdings = data
    },
    disableOrderFirstTime (state) {
      state.orderFirstTimeFlag = false
    },
    disableMwFirstTime (state) {
      state.marketWatchFirstTimeFlag = false
    },
    disablePositionFirstTime (state) {
      state.positionFirstTimeFlag = false
    },
    disableUserFirstTime (state) {
      state.userFirstTimeFlag = false
    },
    disableHoldingFirstTime (state) {
      state.holdingFirstTimeFlag = false
    },
    removeMyOpenOrder (state, id) {
      const index = state.openOrders.findIndex((s) => s.id === id) // find toast
      var value = state.openOrders[index]
      value.status = 'CANCELLED'
      state.openOrders.splice(index, 1)
      state.executedOrders.unshift(value)
    },
    updateUserNotiCount (state) {
      state.user.notificationCount = 0
    },
    setVirtualMoney (state, flag) {
      state.setVirtualMoney = flag
    },
    setClearHistory (state, flag) {
      state.clearHistory = flag
    },
    setFeedback (state, flag) {
      state.feedback = flag
    },
    dailyPosReport (state, flag) {
      state.dailyPosReport = flag
    },
    setchartMw (state, mw) {
      state.chartMw = mw
    },
    setDarkMode (state, flag) {
      state.darkMode = flag
      localStorage.setItem('darkMode', flag)
      document.documentElement.setAttribute('data-bs-theme', flag ? 'dark' : 'light')
    }
  },
  actions: {
    updateTick (commit, payload) {
      commit('updateTick', payload)
    },
    updateMarketWatch (commit, payload) {
      commit('updateMarketWatch', commit)
    },
    addToast (commit, toast) {
      commit('addToast', toast)
    },
    clearToast (commit, title) {
      commit('clearToast', title)
    },
    updateMyScripts (commit, script) {
      commit('updateMyScripts', script)
    },
    addToMyScripts (commit, script) {
      commit('addToMyScripts', script)
    },
    removeMyScripts (commit, script) {
      commit('removeMyScripts', script)
    },
    addToMarketWatch (commit, mw) {
      commit('addToMarketWatch', mw)
    },
    removeMyMarketWatch (commit, instrumentToken) {
      commit('removeMyMarketWatch', instrumentToken)
    },
    setBuySell (commit, data) {
      commit('setBuySell', data)
    },
    closeBuySell (commit) {
      commit('closeBuySell')
    },
    updateExecutedOrder (commit, data) {
      commit('updateExecutedOrder', data)
    },
    updateOpenOrder (commit, data) {
      commit('updateOpenOrder', data)
    },
    updatePosition (commit, data) {
      commit('updatePosition', data)
    },
    addOpenOrder (commit, data) {
      commit('addOpenOrder', data)
    },
    disableOrderFirstTime (commit) {
      commit('disableOrderFirstTime', '')
    },
    disableMwFirstTime (commit) {
      commit('disableMwFirstTime', '')
    },
    disablePositionFirstTime (commit) {
      commit('disablePositionFirstTime', '')
    },
    disableUserFirstTime (commit) {
      commit('disableUserFirstTime', '')
    },
    disableHoldingFirstTime (commit) {
      commit('disableHoldingFirstTime', '')
    },
    updateHolding (commit, data) {
      commit('updateHolding', data)
    },
    removeMyOpenOrder (commit, data) {
      commit('removeMyOpenOrder', data)
    },
    updateUser (commit, data) {
      commit('updateUser', data)
    },
    updateUserNotiCount (commit) {
      commit('updateUserNotiCount', '')
    },
    setVirtualMoney (commit, flag) {
      commit('setVirtualMoney', flag)
    },
    setClearHistory (commit, flag) {
      commit('setClearHistory', flag)
    },
    setFeedback (commit, flag) {
      commit('setFeedback', flag)
    },
    dailyPosReport (commit, flag) {
      commit('dailyPosReport', flag)
    },
    showMw (commit, flag) {
      commit('showMw', flag)
    },
    setchartMw (commit, mw) {
      commit('setchartMw', mw)
    },
    setDarkMode (commit, flag) {
      commit('setDarkMode', flag)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js